import React from 'react';
import { useHistory, useLocation } from 'react-router';
import { Button, ButtonGroup } from 'reactstrap';
import qs from 'qs';

import { fullPathWithParams, } from '../util';

export default function QueryButtonGroup(props) {
  const { paramName, label, options = [], defaultValue, disabled, forcedValue, ...extraProps } = props;
  const history = useHistory();
  const location = useLocation();
  const { [paramName]: queryValue = defaultValue } = qs.parse(decodeURI(location.search.slice(1)));
  // forcedValue: クエリの値によらず選択状態を固定したいとき（通常 disabled と併用）
  const value = forcedValue ?? queryValue;
  const onClick = (optionValue) => {
    const path = fullPathWithParams({ [paramName]: optionValue, page: undefined }, location);
    history.replace(encodeURI(path));
  };

  return (
    <div {...extraProps}>
      {label != null && <div className="text-muted small">{label}</div>}
      <ButtonGroup>
        {
          options.map(({ label: optionLabel, value: optionValue }) => (
            <Button
              key={optionValue}
              color="secondary"
              outline={value !== optionValue}
              onClick={() => onClick(optionValue)}
              disabled={disabled}
            >
              {optionLabel}
            </Button>
          ))
        }
      </ButtonGroup>
    </div>
  );
};
